import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import PriceBox from "../PriceBox";
import { _Anchorable } from "../../style/CommonStyles";
import { _PaymentContent, _PaymentDisplay, _PaymentLabel, _PriceLink } from "../styles";
var PaymentGroup = function PaymentGroup(_ref) {
  var section = _ref.section,
    title = _ref.title,
    payments = _ref.payments;
  return [/*#__PURE__*/React.createElement(_PaymentLabel, {
    key: "".concat(section, "-title")
  }, title), /*#__PURE__*/React.createElement(_PaymentContent, {
    key: "".concat(section, "-contents"),
    doubleWidth: true
  }, payments.map(function (charge, idx) {
    return /*#__PURE__*/React.createElement(_PaymentDisplay, {
      key: "".concat(charge.title).concat(idx)
    }, /*#__PURE__*/React.createElement(_Anchorable, null, /*#__PURE__*/React.createElement(_PriceLink, {
      href: charge.link,
      canceled: charge.canceled,
      refunded: charge.refunded,
      target: "_blank",
      rel: "noopener"
    }, /*#__PURE__*/React.createElement(PriceBox, {
      charge: charge
    }))));
  }))];
};
export default PaymentGroup;